<script>
import { useVModel } from "@vueuse/core";
import { provide } from "vue";

export default {
  name: "ShTabs",
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
  },
  setup(props, { emit }) {
    const activeName = useVModel(props, "modelValue", emit);
    // 给xtx-tabs-panel传值
    provide("activeName", activeName);
    // 点击选项卡对应的处理函数
    const tabClick = (name, index) => {
      activeName.value = name;
      // 触发一个点击自定义时间
      emit("tab-click", { name, index });
    };

    return { activeName, tabClick };
  },
  render() {
    //获取插槽节点内容
    const panels = this.$slots.default();
    //动静态panelsde组件集合
    const dynamicPanels = [];
    panels.forEach((item) => {
      //静态
      if (item.type.name === "ShTabsPanel") {
        dynamicPanels.push(item);
      } else {
        //v-for渲染而来
        item.children.forEach((item) => {
          dynamicPanels.push(item);
        });
      }
    });
    const nav = (
      <nav>
        {panels.map((item, i) => {
          return (
            <a
              onclick={() => this.tabClick(item.props.name, i)}
              class={{ active: item.props.name === this.activeName }}
              href="javascript:;"
            >
              {item.props.label}
            </a>
          );
        })}
      </nav>
    );
    return <div class="sh-tabs">{[nav, dynamicPanels]}</div>;
  },
};
</script>

<style lang="less">
.sh-tabs {
  background: #fff;
  > nav {
    height: 60px;
    line-height: 60px;
    display: flex;
    border-bottom: 1px solid rgb(222, 222, 222);
    > a {
      width: 110px;
      border-right: 1px solid rgb(222, 222, 222);
      text-align: center;
      font-size: 16px;
      &.active {
        border-top: 2px solid @shColor;
        height: 60px;
        background: #fff;
        line-height: 56px;
      }
    }
  }
}
</style>
